import WarningIcon from '@mui/icons-material/Warning';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { FormEvent } from 'react';

interface RemoveScheduleReportDialogContentProps {
  onClose: () => void;
  onRemove: () => void;
  title: string;
  description: string;
}

const RemoveScheduleReportDialogContent = ({
  onClose,
  onRemove,
  title,
  description,
}: RemoveScheduleReportDialogContentProps) => {
  const onRemoveScheduleReport = (event: FormEvent) => {
    onRemove();
    event.preventDefault();
  };

  return (
    <Box p={2} component="form" onSubmit={onRemoveScheduleReport}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <WarningIcon fontSize="small" />
          <Box component="span">{title}</Box>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          No, don't remove
        </Button>
        <Button variant="contained" color="error" type="submit">
          Yes, remove
        </Button>
      </DialogActions>
    </Box>
  );
};

export default RemoveScheduleReportDialogContent;
